import {IS_PROD_ENV} from '../../../constants/index.js'
import {formatAmount} from '../../../constants/StripeCurrencies.js'
import {FormattedRealDate} from '../../FormattedDate.js'
import {formatTime} from '../../../date.js'
import User from './User.js'

export default function StripeComment({
  comment: {date, chargeID, amount, currency, user},
}) {
  const isTest = !IS_PROD_ENV

  return (
    <dl className="list--order-data list--timeline-point">
      <dt className="list__item--order-data list__title--timeline-point">
        <FormattedRealDate value={date} format={formatTime} />
      </dt>
      <dd className="list__item--order-data list__item--timeline-point">
        <div className="message--timeline-point">
          {`A ${formatAmount(amount, currency)} payment`}
          {' was processed via Stripe'}
          <span className="divider--left">
            <a
              className="btn--link"
              href={`https://dashboard.stripe.com${
                isTest ? '/test' : ''
              }/payments/${chargeID}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              View details →
            </a>
          </span>
        </div>
        {user && <User email={user} />}
      </dd>
    </dl>
  )
}
